var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapWrapper",staticClass:"ui-map-chart-wrapper"})
}
var staticRenderFns = []

export { render, staticRenderFns }